import Image from 'next/image';
import Link from 'next/link';
import { Celebrity } from '@/data/celebrities';

interface CelebrityCardProps {
  celebrity: Celebrity;
}

export default function CelebrityCard({ celebrity }: CelebrityCardProps) {
  // Convert percentage score to 10-point scale
  const tenPointScore = (celebrity.score / 10).toFixed(1);

  return (
    <Link href={`/celebrities/${celebrity.slug}`} className="group">
      <div className="relative overflow-hidden rounded-lg bg-white shadow-md transition-all hover:shadow-lg">
        <div className="relative aspect-[3/4] w-full">
          <Image
            src={celebrity.image}
            alt={`${celebrity.name} photo`}
            fill
            className="object-cover transition-transform duration-300 group-hover:scale-105"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <div className="p-4 relative z-10">
          <h3 className="text-lg font-semibold text-gray-900 group-hover:text-white transition-colors duration-300">
            {celebrity.name}
          </h3>
          <div className="mt-1 flex items-center justify-between">
            <span className="text-sm text-gray-600 group-hover:text-gray-200 transition-colors duration-300">
              {celebrity.nationality}
            </span>
            <span className="text-lg font-bold text-blue-600 group-hover:text-blue-400 transition-colors duration-300">
              {tenPointScore}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
